var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgShot = function SvgShot(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Buttons/Shot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camera/Action-bar",
    transform: "translate(-153.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buttons/Shot",
    transform: "translate(153.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35,-4.49023534e-14 C54.3299662,-4.49023534e-14 70,15.6700338 70,35 C70,54.3299662 54.3299662,70 35,70 C15.6700338,70 2.82884827e-12,54.3299662 2.82884827e-12,35 C2.82884827e-12,15.6700338 15.6700338,-4.49023534e-14 35,-4.49023534e-14 Z M35,7 C19.536027,7 7,19.536027 7,35 C7,50.463973 19.536027,63 35,63 C50.463973,63 63,50.463973 63,35 C63,19.536027 50.463973,7 35,7 Z M35,10.1111111 C48.7457538,10.1111111 59.8888889,21.2542462 59.8888889,35 C59.8888889,48.7457538 48.7457538,59.8888889 35,59.8888889 C21.2542462,59.8888889 10.1111111,48.7457538 10.1111111,35 C10.1111111,21.2542462 21.2542462,10.1111111 35,10.1111111 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shot.df6beed42a3c27b73b5c07e38ffc35dd.svg";